import React, { useCallback, useMemo } from 'react'
import { Button, Grid, Stack, Typography } from '@mui/material'
import { WALLET_SETUP_ROUTES } from '@utils/walletSetupRoutes'
import plug from '@assets/icons/plug-logo.png'
import { useLocation, useNavigate } from 'react-router-dom'
import Touchable from '@components/Touchable'
import useToast from '@hooks/useToast'
import { useTranslation } from 'react-i18next'

interface SeedWord {
  index: number
  word: string
}

export const WalletSetupBackupSeed = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { setToastMessage } = useToast()

  const { t } = useTranslation()

  const words = useMemo(() => {
    const seedPhrase = location.state?.mnemonic?.split(' ') || []

    let wordsOrdered: SeedWord[] = []

    for (let i = 0; i < seedPhrase.length / 2; i++) {
      wordsOrdered.push({ index: i + 1, word: seedPhrase[i] })
      wordsOrdered.push({
        index: i + seedPhrase.length / 2 + 1,
        word: seedPhrase[i + seedPhrase.length / 2],
      })
    }

    return wordsOrdered
  }, [location.state])

  const onCopy = () => {
    setToastMessage(t('seedBackup.copied'))
    navigator.clipboard.writeText(location.state?.mnemonic || '')
  }

  const proceed = useCallback(() => {
    if (location.state?.fromSettings) {
      navigate(-1)
    } else {
      navigate(WALLET_SETUP_ROUTES.PASSWORD)
    }
  }, [navigate])

  return (
    <Stack
      direction="column"
      spacing={2}
      alignContent="center"
      justifyContent="center"
      flex={1}
      height="100%"
      justifyItems="center"
      px={4}
    >
      <img src={plug} width="100px" style={{ alignSelf: 'center' }} />
      <Stack spacing={0.5}>
        <Typography fontWeight="bold" textAlign="center" variant="h5">
          {t('seedBackup.title')}
        </Typography>
        <Typography textAlign="center" variant="body2" color="text.secondary">
          {t('seedBackup.description')}
        </Typography>
      </Stack>
      <Stack spacing={2}>
        <Touchable style={{ marginLeft: 15 }} onClick={onCopy}>
          <Grid
            container
            bgcolor={(theme) => theme.palette.background.paper}
            borderRadius={1}
            spacing={2}
            pb={2}
            mt={0.5}
          >
            {words.map((word) => (
              <Grid key={word.word} item xs={6}>
                <Stack flexDirection="row">
                  <Typography mr={1} variant="body2" color="text.secondary">
                    {word.index}
                  </Typography>
                  <Typography variant="body1">{word.word}</Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Touchable>
        <Button variant="rainbow" fullWidth onClick={proceed}>
          I've saved these words
        </Button>
      </Stack>
    </Stack>
  )
}
